
import { useLanguage } from '../../../contexts/LanguageContext';
import { translations } from '../../../mocks/translations';

export default function RemarksSection() {
  const { language } = useLanguage();
  const t = translations[language].remarks;

  return (
    <div className="space-y-8">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">{t.title}</h2>
        <p className="text-lg text-gray-600">{t.subtitle}</p>
      </div>

      <div className="max-w-4xl mx-auto">
        <div className="bg-white p-8 rounded-xl border-2 border-orange-200 shadow-lg">
          <div className="flex items-start gap-6">
            <div className="w-14 h-14 flex items-center justify-center bg-orange-100 rounded-xl flex-shrink-0">
              <i className="ri-alert-line text-2xl text-orange-600"></i>
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-bold text-gray-900 mb-4">{t.mainTitle}</h3>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                {t.mainDescription}
              </p>
              <div className="bg-orange-50 p-6 rounded-lg border border-orange-100">
                <h4 className="text-sm font-bold text-gray-900 mb-3">{t.keyPoints}</h4>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center bg-orange-200 rounded-md flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-line text-xs text-orange-700"></i>
                    </div>
                    <span className="text-sm text-gray-700">{t.point1}</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center bg-orange-200 rounded-md flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-line text-xs text-orange-700"></i>
                    </div>
                    <span className="text-sm text-gray-700">{t.point2}</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center bg-orange-200 rounded-md flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-line text-xs text-orange-700"></i>
                    </div>
                    <span className="text-sm text-gray-700">{t.point3}</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center bg-orange-200 rounded-md flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-line text-xs text-orange-700"></i>
                    </div>
                    <span className="text-sm text-gray-700">{t.point4}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
          <div className="bg-white p-6 rounded-xl border border-gray-200 text-center hover:shadow-md transition-shadow">
            <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mx-auto mb-4">
              <i className="ri-government-line text-xl text-teal-600"></i>
            </div>
            <h4 className="text-sm font-bold text-gray-900 mb-2">{t.governmentApprovals}</h4>
            <p className="text-xs text-gray-600">{t.governmentApprovalsDescription}</p>
          </div>

          <div className="bg-white p-6 rounded-xl border border-gray-200 text-center hover:shadow-md transition-shadow">
            <div className="w-12 h-12 flex items-center justify-center bg-emerald-100 rounded-lg mx-auto mb-4">
              <i className="ri-file-list-3-line text-xl text-emerald-600"></i>
            </div>
            <h4 className="text-sm font-bold text-gray-900 mb-2">{t.documentation}</h4>
            <p className="text-xs text-gray-600">{t.documentationDescription}</p>
          </div>

          <div className="bg-white p-6 rounded-xl border border-gray-200 text-center hover:shadow-md transition-shadow">
            <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mx-auto mb-4">
              <i className="ri-refresh-line text-xl text-teal-600"></i>
            </div>
            <h4 className="text-sm font-bold text-gray-900 mb-2">{t.regularUpdates}</h4>
            <p className="text-xs text-gray-600">{t.regularUpdatesDescription}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
